export default {
  save ({ state }) {
    window.localStorage.setItem('saveEmailPass', state.saveEmailPass)
    if (state.saveEmailPass) {
      window.localStorage.setItem('email', state.email)
      window.localStorage.setItem('password', state.password)
    } else {
      window.localStorage.removeItem('email')
      window.localStorage.removeItem('password')
    }
  }
}
